import React from "react";

interface TextAreaProps {
  value: string;
  onChange?: (value: string) => void;
}

const TextArea = (props: TextAreaProps) => {
  const { value, onChange } = props;
  return (
    <textarea
      className="dui-text-area"
      onChange={(e) => {
        onChange?.(e.target.value);
      }}
      value={value}
    />
  );
};

export default TextArea;
